import { StyleSheet } from 'react-native';

import { defaultBgColor } from '@/feature/alerts/components/Modal';

export const betslipModalStyles = StyleSheet.create({
    contentContainer: {
        backgroundColor: defaultBgColor,
    },
    listContent: {
        paddingHorizontal: 16,
        paddingBottom: 16,
    },
    listContentLargerPadding: {
        paddingHorizontal: 16,
        paddingBottom: 32,
    },
    sectionHeader: {
        backgroundColor: defaultBgColor,
    },
});
